import {
  OrderSessionsQuery,
  SortOrder,
  useOrderSessionsQuery,
} from "@/queries/autogenerate/graphql";
import { CurrentUser, UserContext } from "../Page";

interface GetLatestOrderSessionsProps {
  recipeId?: string;
  spinner?: boolean;
  children: (
    recipes: OrderSessionsQuery["orderSessions"]
  ) => React.ReactNode | null;
}

const GetLatestOrderSessions: React.FC<GetLatestOrderSessionsProps> = (
  props
) => {
  return (
    <UserContext.Consumer>
      {(user) => <GetLatestOrderSessionsInner {...props} user={user} />}
    </UserContext.Consumer>
  );
};

interface GetLatestOrderSessionsInnerProps extends GetLatestOrderSessionsProps {
  user: CurrentUser;
}

const GetLatestOrderSessionsInner: React.FC<
  GetLatestOrderSessionsInnerProps
> = ({ recipeId, spinner, children, user }) => {
  const [{ fetching, error, data }] = useOrderSessionsQuery({
    requestPolicy: "cache-and-network",
    variables: {
      schoolID: user.school?.id || "",
      where: {
        recipeId: { equals: recipeId },
        orders: { some: { deletedAt: null } },
      },
      orderBy: { createdAt: SortOrder.Desc },
      take: 1,
    },
  });

  if (!data) {
    if (error) return null;

    if (fetching) {
      if (!spinner) {
        return null;
      }

      return (
        <div>
          <div className="spinner" />
        </div>
      );
    }
  }
  if (!data) return null;

  return (
    <>
      {children(data.orderSessions.filter((os) => os.recipe?.id == recipeId))}
    </>
  );
};

export default GetLatestOrderSessions;
